module.exports = __webpack_public_path__ + "static/assets/f16ba4a1ac3af78fccc89a983b27cd35.svg";